import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import CompareTable from '../components/CompareTable/CompareTable.js';
import TabularData from '../data/TabularData.js';
import { MapTo } from '@adobe/aem-react-editable-components';
import * as _ from 'lodash-es';
import initSecContext from '../data/initSecContext.js';
import ppUtilities from '../ppUtilities';
import LocalContext from '../data/Localization.js';

class StandalonTableSection extends Component {
	constructor(props) {
		super(props);
		this.dynamicTableRoot = document.querySelector('.ppc-table-wrapper');

		this.dialogInfo = this.props.fromDialog;
		this.setLocalizationText();
		this.initSecContext = initSecContext.getPropsContext();
		this.ctID = this.initSecContext.ctID;
		this.state = {
			tabularData: 'no_data_back',
			error: null,
		};
		this.tableUpdate = {};
		this.tableUpdateCallback = this.tableUpdateCallback.bind(this);
		initSecContext.setPretTableCallBack(this.tableUpdateCallback);
		this.comparisonTriggered = this.comparisonTriggered.bind(this);
		initSecContext.setComparsionUpdate(this.comparisonTriggered);
		this.handleComparisonSelection = this.handleComparisonSelection.bind(this);
		this.handleCancelComparions = this.handleCancelComparions.bind(this);
	}

	initDataCalls() {
		let endPointPromise = new Promise((resolve, reject) => {
			TabularData.normalized(this.tableUpdate.lookUpByProductPath, this.dialogInfo.pp_comparison_path, resolve, reject);
		});

		endPointPromise.then((tabularData) => {
			this.updateComparableProducts(tabularData.products);
			// set comparable prod to app context
			initSecContext.setComparableProducts(tabularData.products);
			this.setState({
				tabularData,
				compTableActive: this.tableUpdate.compTableActive,
				comparableProducts: this.tableUpdate.comparableProducts,
			});
		});
	}

	updateComparableProducts(products) {
		// remove products not on the csv file
		let comparableProducts = [];
		this.tableUpdate.comparableProducts.forEach((prod) => {
			products.forEach((compProd) => {
				if (compProd.id == prod.id) {
					comparableProducts.push(prod);
				}
			});
		});
		this.tableUpdate.comparableProducts = comparableProducts;
	}

	setLocalizationText() {
		let labels = {
			compareBtn: this.dialogInfo.compareBtn,
			compareProductHeading: this.dialogInfo.compareProductHeading,
			compareProductsHeading: this.dialogInfo.compareProductsHeading,
			cancelButton: this.dialogInfo.cancelButton,
			selectProdToCompare: this.dialogInfo.selectProdToCompare,
			selectItemsToHeading: this.dialogInfo.selectItemsToHeading,
		};
		LocalContext.setTableLabels(labels);
	}

	handleComparisonSelection(activeCardId) {
		initSecContext.ribbonActiveComparison(activeCardId);
	}

	tableUpdateCallback(tableUpdate) {
		this.tableUpdate = tableUpdate;
		this.initDataCalls();
	}

	handleCancelComparions() {
		initSecContext.handleCancelComparions();
	}

	comparisonTriggered({ compTableActive, comparableProducts }) {
		let currState = this.state.comparableProducts;
		let updatedProducts = comparableProducts;
		comparableProducts = currState.map((prod) => {
			let tempProd = prod;
			updatedProducts.forEach((updatedP) => {
				if (updatedP.id == prod.id) {
					tempProd.isSelected = updatedP.isSelected;
				}
			});
			return tempProd;
		});
		this.setState({
			compTableActive,
			comparableProducts,
		});
	}

	render() {
		let tabularData = this.state.tabularData;
		let hasComparisonData = tabularData !== 'no_data_back';
		return ReactDOM.createPortal(
			<React.Fragment>
				{hasComparisonData && (
					<CompareTable
						comparisonTableId={this.tableUpdate.comparisonTableId}
						compTableActive={this.state.compTableActive}
						comparableProducts={this.state.comparableProducts}
						handleComparisonSelection={this.handleComparisonSelection}
						tabularData={this.state.tabularData}
						handleCancelComparions={this.handleCancelComparions}
					/>
				)}
			</React.Fragment>,
			this.dynamicTableRoot
		);
	}
}

class StandalonTableSectionApp extends Component {
	constructor(props) {
		super(props);
		this.initSecContext = initSecContext.getPropsContext();
		this.isLastSection = this.initSecContext.isLast;
	}

	render() {
		if (!this.isLastSection) {
			return null;
		}
		let tabProps = this.props.tableProps ? this.props.tableProps : this.props;
		return <StandalonTableSection fromDialog={tabProps} />;
	}
}

MapTo('esri-sites/components/content/product-pricing-comparison-table')(StandalonTableSectionApp);
export default StandalonTableSectionApp;
